import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatCalendar, MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthState } from '@app/core/states/auth.state';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { UiCustomModalWrapperModule } from '@radioking/ui/custom-modal-wrapper';
import moment, { Moment } from 'moment-timezone';
import { UiMobileCloseButtonModule } from '../mobile-close-button/src/lib/ui-mobile-close-button.module';

interface DialogData {
  date?: moment.Moment;
  minDate?: moment.Moment;
  maxDate?: moment.Moment;
}
export const RK_DATE_FORMATS = {
  parse: {
    dateInput: 'L',
    timeInput: 'HH:mm',
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
    timeInput: 'HH:mm',
    timeOptionLabel: 'HH:mm',
  },
};

@Component({
  selector: 'rk-datepicker-header',
  standalone: true,
  imports: [MatDatepickerModule, TranslateModule],
  styles: `
    button {
      background: white;
      border-radius: 4px;
      height: 42px;
      padding: 10px 15px;
      margin-right: auto;
    }
  `,
  template: ` <mat-calendar-header>
    <button mat-icon-button (click)="todayClicked()" translate>GLOBAL.MOB_TODAY</button>
  </mat-calendar-header>`,
})
export class DatepickerHeaderComponent {
  @Output()
  todayClickedEvent = new EventEmitter<void>();
  public todayClicked(): void {}
}

@Component({
  selector: 'rk-mobile-date-picker-dialog',
  standalone: true,
  imports: [
    MatDatepickerModule,
    UiMobileCloseButtonModule,
    UiCustomModalWrapperModule,
    TranslateModule,
  ],
  templateUrl: './mobile-date-picker-dialog.component.html',
  styleUrl: './mobile-date-picker-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: RK_DATE_FORMATS },
  ],
})
export class MobileDatePickerDialogComponent implements OnInit {
  headerComponent = DatepickerHeaderComponent;
  @Input()
  locale: string;

  @ViewChild(MatCalendar, { static: true })
  calendar: MatCalendar<Moment>;

  selected: moment.Moment = null;

  private readonly _adapter = inject<DateAdapter<Moment>>(DateAdapter);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public readonly dialogRef: MatDialogRef<MobileDatePickerDialogComponent>,
    private readonly store: Store,
  ) {
    this.selected = data.date || moment();
  }

  ngOnInit(): void {
    this._adapter.setLocale(this.store.selectSnapshot(AuthState.userLang));
    this.headerComponent.prototype.todayClicked = this.todayClicked.bind(this);
  }

  exitPanel() {
    this.dialogRef.close();
  }

  onSubmit() {
    this.dialogRef.close(this.selected);
  }

  public todayClicked(): void {
    this.calendar.activeDate = this._adapter.today();
    this.selected = this._adapter.today();
  }
}
